import { render, staticRenderFns } from "./ReferencesSection.vue?vue&type=template&id=67252e2e&scoped=true&"
import script from "./ReferencesSection.vue?vue&type=script&lang=js&"
export * from "./ReferencesSection.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesSection.vue?vue&type=style&index=0&id=67252e2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67252e2e",
  null
  
)

export default component.exports